import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, AttributeReport, DeclarationData, Page } from '../../model';
import { buildQuery } from '../../util';
import { Params } from '@angular/router';

interface ArticleNoteUpdate {
  id?: string;
  articleId?: string;
  summary?: string;
}

@Injectable({ providedIn: 'root' })
export class AttributeReportService extends _Service<AttributeReport> {
  constructor() {
    super('api/attribute-report');
  }

  listForCompany = async (companyId: string, queryParams: Params) =>
    this.http.get<Page<AttributeReport>>(`api/company/${companyId}/attribute-report` + buildQuery(queryParams));

  updateNotes = async (reportId: AppId, notes: ArticleNoteUpdate[]) =>
    this.http.put(`api/attribute-report/${reportId}/notes`, notes);

  updateMeta = async (
    reportId: AppId,
    payload: { name: string; startDate: string | null; endDate: string | null; declarationData?: DeclarationData }
  ) => this.http.put(`api/attribute-report/${reportId}`, payload);

  /** @param language optional `en`/`de` override — omit for the server's `en` default (D1). */
  downloadDoc = async (reportId: AppId, language?: string) =>
    this.http.getBlob(`api/attribute-report/${reportId}/pdf` + buildQuery({ language }));

  downloadTechnicalDocumentation = async (reportId: AppId) =>
    this.http.getBlob(`api/attribute-report/${reportId}/technical-documentation/pdf`);
}
